const htmlParagraphNodeToLatexPrinter = (node, printChildren) => {
  var _a;
  const isEmpty = !node.children || // NB: Froala renders regular line-breaks as a paragraph containing a
  // single line-break.
  // If we encounter this, then treat it as an empty paragraph, which will
  // trigger a single line-break.
  node.children.length === 1 && ((_a = node.children[0]) == null ? void 0 : _a.nodeType) === "html" && node.children[0].tagName === "br";
  if (isEmpty) {
    return "\xA0\\\\\n";
  }
  const children = printChildren(node.children).join("");
  return `${children}\\\\
`;
};

export { htmlParagraphNodeToLatexPrinter };
//# sourceMappingURL=html.paragraph.js.map
